import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { GrFormView } from "react-icons/gr";
import ProjectAllocation from "./projectAllocationPopup";
import NodeInstance from "../../../../Global/nodeAxios";
import { setAppError } from "../../../../store/userSlice";
import VisaProjectSummary from "./visaProjectwisesummary";
import SmartDownloadPagination from "../../../../components/SmartDataTable/SmartDownloadPagination";
import {
  VISA_ALLOCATION_COLUMNS,
  VISA_ALLOCATION_CONFIG,
  VISA_ALLOCATION_SEARCHABLE_FIELDS,
} from "./VisaAllocationConstants";

export default function VisaAllocationlistview() {
  const dispatch = useDispatch();
  const token = useMemo(() => localStorage.getItem("nodeToken"), []);

  const [tabletwoId, setTabletwoId] = useState();
  const [selectedRow, setSelectedRow] = useState(null);
  const [project, setProject] = useState();
  const [ApiTrigger, setApiTrigger] = useState(false);
  const [popupOpen, setPopUpopen] = useState(false);
  const [visaId, setVisaId] = useState();
  const [popUpdata, setPopUpData] = useState();
  const [currentData, setCurrentData] = useState([]);
  const detailSectionRef = useRef(null);

  const projectsData = useCallback(async (id) => {
    try {
      const response = await NodeInstance.get(`/dashboard/visa-stock/getProjectsByVisaId/${id}`);
      if (response.status === 200) setProject(response.data.data);
    } catch (e) {
      console.log("error fetching projects", e);
    }
  }, []);

  useEffect(() => {
    if (tabletwoId !== undefined) projectsData(tabletwoId);
  }, [tabletwoId, ApiTrigger]);

  const handleRowClick = (item) => {
    setTabletwoId(item.id);
    setSelectedRow(item.id);
    setTimeout(() => {
      detailSectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };

  const handleIconClicked = (e, id, item) => {
    e.stopPropagation();
    setPopUpopen(true);
    setVisaId(id);
    setPopUpData(item);
  };

  const handleDataLoad = useCallback((data) => {
    setCurrentData(data || []);
  }, []);

  const handleDownloadComplete = useCallback((result) => {
    dispatch(setAppError({ msg: `Excel Downloaded (${result.recordCount} records)`, color: "success" }));
  }, [dispatch]);

  const handleDownloadError = useCallback((error) => {
    dispatch(setAppError({ msg: error.message || "Download failed" }));
  }, [dispatch]);

  // Custom cell renderer
  const renderCustomCell = useCallback((item, column, rowIndex, currentPage, pageSize) => {
    if (column.key === 'serial') {
      return (currentPage - 1) * pageSize + rowIndex + 1;
    }

    if (column.key === 'ajeer') {
      return item.ajeer ?? "-";
    }

    if (column.key === 'unallocated') {
      return item.unallocated ?? 0;
    }

    if (column.key === 'visa_return_requested_qty') {
      return item.visa_return_requested_qty ?? 0;
    }

    if (column.key === 'visa_return_approval_qty') {
      return item.visa_return_approval_qty ?? 0;
    }

    if (column.key === 'action') {
      return (
        <button
          onClick={(e) => handleIconClicked(e, item.id, item)}
          className="p-1 rounded hover:bg-slate-100"
        >
          <GrFormView size={"1.5rem"} />
        </button>
      );
    }

    if (column.key === 'Visa_Status') {
      return (
        <span className={`px-2 py-1 rounded-full text-xs ${
          item.Visa_Status === "Fully Allocated"
            ? "bg-green-100 text-green-700"
            : item.Visa_Status === "Partially Allocated"
            ? "bg-yellow-100 text-yellow-700"
            : "bg-red-100 text-red-600"
        }`}>
          {item.Visa_Status}
        </span>
      );
    }

    return null;
  }, [handleIconClicked]);

  const selectedRowData = currentData?.find((i) => i.id === tabletwoId);

  return (
    <div className="flex flex-col gap-4 p-2">
      <SmartDownloadPagination
        apiEndpoint={VISA_ALLOCATION_CONFIG.API_ENDPOINT}
        downloadEndpoint={VISA_ALLOCATION_CONFIG.DOWNLOAD_ENDPOINT}
        token={token}
        columns={VISA_ALLOCATION_COLUMNS}
        searchableFields={VISA_ALLOCATION_SEARCHABLE_FIELDS}
        enableHighlighting={true}
        defaultPageSize={VISA_ALLOCATION_CONFIG.DEFAULT_PAGE_SIZE}
        pageSizeOptions={VISA_ALLOCATION_CONFIG.PAGE_SIZE_OPTIONS}
        downloadFilename={VISA_ALLOCATION_CONFIG.DOWNLOAD_FILENAME}
        enableDownload={true}
        enableSearch={true}
        searchPlaceholder={VISA_ALLOCATION_CONFIG.SEARCH_PLACEHOLDER}
        searchDebounceMs={VISA_ALLOCATION_CONFIG.DEBOUNCE_MS}
        renderCustomCell={renderCustomCell}
        onDataLoad={handleDataLoad}
        onDownloadComplete={handleDownloadComplete}
        onDownloadError={handleDownloadError}
        noDataMessage={VISA_ALLOCATION_CONFIG.NO_DATA_MESSAGE}
        onRowClick={handleRowClick}
        trigger={ApiTrigger}
      />

      {/* Row Detail Section */}
      {tabletwoId && (
        <div ref={detailSectionRef} className="bg-white rounded-md shadow-sm border border-slate-100 p-4">
          <div className="flex items-center justify-between mb-3 uppercase">
            <h3 className="font-semibold">
              Project Allocation —{" "}
              <span className="text-blue">{selectedRowData?.vrf_reference_number}</span>
            </h3>
            <button
              className="text-gray-400 hover:text-red"
              onClick={() => { setTabletwoId(undefined); setSelectedRow(null); }}
            >
              ✕ Close
            </button>
          </div>
          <VisaProjectSummary
            tabletwoId={tabletwoId}
            projectsByVisaData={project}
            setApiTrigger={setApiTrigger}
          />
        </div>
      )}

      {popupOpen && (
        <ProjectAllocation
          showPromptElement={popupOpen}
          setPopUpopen={setPopUpopen}
          visaId={visaId}
          popUpdata={popUpdata}
          setApiTrigger={setApiTrigger}
        />
      )}
    </div>
  );
}
